export default {"src":"/_next/static/media/positionOpposition.3d61a354.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};